import React from 'react';
import { Link } from 'react-router-dom';
import { CollaboratorAvatar } from '@/features/Collaborators/Shared';

interface NameCellProps {
    name: string;
    subtitle?: string | null;
    avatarUrl?: string | null;
    activityStatus?: string;
    isRaroAcademyAlumnus?: boolean;
    linkTo?: string;
}
const NameCell: React.FC<NameCellProps> = ({ name, subtitle, avatarUrl, activityStatus, isRaroAcademyAlumnus, linkTo }) => {
    return (
        <div className="flex items-center">
            <CollaboratorAvatar
                photoUrl={avatarUrl}
                name={name}
                size="small"
                activityStatus={activityStatus}
                isRaroAcademyAlumnus={isRaroAcademyAlumnus}
            />
            <div className="ml-4">
                <div className="text-sm font-medium">
                    {linkTo ? (
                        <Link to={linkTo} className="text-indigo-600 hover:text-indigo-800 hover:underline">
                            {name}
                        </Link>
                    ) : (
                        <span className="text-gray-900">{name}</span>
                    )}
                </div>
                {subtitle && (
                    <div className="text-sm text-gray-500">
                        {subtitle}
                    </div>
                )}
            </div>
        </div>
    );
};

export default NameCell; 
